import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Icon } from '@src-common/view/components/Icon';

import s from './styles.module.css';

interface IErrorLayoutProps {
  code?: number | never;
  title: React.ReactNode;
  description: React.ReactNode;
  isLinkToIndexShown?: boolean;
}

const ErrorLayout = ({ code, title, description, isLinkToIndexShown }: IErrorLayoutProps) => (
  <>
    <div className={s.container}>
      <h1 className={s.title}>
        {typeof code === 'number' ? `${code}. ` : ''}
        {title}
      </h1>
      <div className={s.description}>{description}</div>

      {isLinkToIndexShown && (
        // reload app
        <a href="/" className={s.link}>
          <FormattedMessage
            defaultMessage="Go to the main page"
            id="2OTR65"
            description="Error page - link to main page"
          />

          <Icon icon="arrow-to-end-in-circle" className={s.linkIcon} />
        </a>
      )}
    </div>
  </>
);

export type { IErrorLayoutProps };
export { ErrorLayout };
